import "./bluebu.styles.css";

export const BlueBu = (props) => {
  return <button className="bluebu">{props.children}</button>;
};
